export function camelize(str: string) {
  return str.replace(/(\d)(_)/g, '$1').replace(/(_)(\S{1})/g, (_, __, b) => b.toUpperCase());
}
